import React from "react";
import { key_property_invest_category } from "../../pages/balance/functions";
import _ from "lodash";
import { useBalanceStore } from "../../_store/balanceStore";

const Property_others_Lists = ["property_money_market", "property_other"];

const No_Property_others_Lists = [
  "property_invest_bond",
  "property_money_market",
];

export const PdfPageInvestTwo_Items = (balanceData) => {
  const tempDebtInvest = balanceData?.debt_long_list
    ?.map(
      (item) =>
        item?.debt_long_others || item?.debt_long_places || item?.debt_long_cars
    )
    ?.flat()
    .filter((item) => item?.personal_or_investment === "investment");

  const totalDebtInvest = tempDebtInvest?.reduce((prev, curr) => {
    if (curr?.type_car) {
        return prev  + Number(curr?.start_amount || 0);
      }
    return prev + Number(curr?.current_price || 0);
  }, 0);

  if (
    !balanceData?.property_invest_list?.length &&
    tempDebtInvest?.length === 0
  ) {
    return [];
  }

  const filterPropertyInvest = balanceData?.property_invest_list?.filter(
    (item) => item?.options_property_invest_category
  );

  const groupInvest = _.groupBy(
    filterPropertyInvest,
    "options_property_invest_category"
  );

  const keyInvest =
      tempDebtInvest?.length > 0 && ![...Object.keys(groupInvest)].includes("property_other")
        ? [...Object.keys(groupInvest), "property_other"]
        : Object.keys(groupInvest);

  let convertGroupInvest = keyInvest?.map((key) => {
    const items = [];

    let total = 0;

    for (let index = 0; index < groupInvest[key]?.length; index++) {
      const element = groupInvest[key][index];
      const itemValue = Object.keys(element);
      let filteredKeys = itemValue?.filter((item) => {
        if (item.includes("lists")) {
          return item;
        }
        return null;
      })[0];
      total += element?.[filteredKeys]?.reduce((prev, curr) => {
        return prev + (curr?.amount || 0);
      }, 0);
    }

    if (key === "property_other") {
      total += totalDebtInvest;
    }


    groupInvest[key]?.forEach((curr) => {
      const itemKeys = Object.keys(curr);
      for (const itemKey of itemKeys) {
        const itemValue = curr[itemKey];
        if (_.isArray(itemValue)) {
          const merge = itemValue?.map((thisItem) => {
            return {
              ...thisItem,
              label: thisItem?.title,
              value: (thisItem?.amount / total) * 100,
            };
          });

          items.push(...merge);
        }
      }

      
    }, []);

    if (key === "property_other") {
        const merge = tempDebtInvest?.map((thisItem, index) => {
         
          return {
            ...thisItem,
            label: thisItem?.address_place || thisItem?.title || thisItem?.title_car,
            amount: thisItem?.current_price || thisItem?.start_amount || 0,
            value: ((thisItem?.current_price || thisItem?.start_amount || 0) / total) * 100,
            reward_amount_per_year: thisItem?.reward_amount_per_year || thisItem?.return_interest || 0,
            color: thisItem?.color || "#000000",
          };
        });

        items.push(...merge);
      }
    return {
      key,
      label: key_property_invest_category[key],
      items,
    };
  });


  return convertGroupInvest;
};

export const PdfPageInvestTwo_Function_Other = () => {};
